import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="detailansicht-zeitpunkt-form"
export default class extends Controller {
	static targets = ["inputDatum"]

	connect() {
		// this.inputDatumTarget.dataset.action = "change->detailansicht-zeitpunkt-form#submit"
	}

	updateDatum({ currentTarget }) {
		this.inputDatumTarget.value = `${currentTarget.value}-01-01`
		this.submit()
	}

	// private

	submit() {
		const [jahr, monat, tag] = this.inputDatumTarget.value.split("-").map(Number)

		if (!Number.isInteger(jahr) || jahr < 1900 || jahr > 2200 || monat > 12 || monat < 1) return

		const zeitpunkt = new Date(jahr, monat - 1, tag)

		if (isNaN(zeitpunkt)) return

		this.element.requestSubmit()
	}
}
